import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import {
    FacetFilterInput,
    RecommendationModule as RecommendationModuleType,
    ScenarioType,
} from '../../types.generated';
import { useListRecommendationsQuery } from '../../graphql/recommendations.generated';
import { RecommendationModule } from '../recommendations/RecommendationModule';
import { useTranslation } from '../../i18n/useTranslation';

type Props = {
    userUrn: string;
    query: string;
    filters: Array<FacetFilterInput>;
};

export const SearchResultsRecommendations = ({ userUrn, query, filters }: Props) => {
    const { t } = useTranslation();
    const scenario = ScenarioType.SearchResults;
    const { data } = useListRecommendationsQuery({
        variables: {
            input: {
                userUrn,
                requestContext: {
                    scenario,
                    searchRequestContext: {
                        query,
                        filters,
                    },
                },
                limit: 3,
            },
        },
        errorPolicy: 'all',
    });
    const recommendationModules = data?.listRecommendations?.modules;
    return (
        <>
            {recommendationModules && !!recommendationModules.length && (
                <div data-testid="recommendation-container-id">
                    <div className="f-bottom-border pa-2">
                        <Typography.Title className="f-text-big-content f-color-dark-black-s100 mb-0">
                            {t('More you may be interested in')}
                        </Typography.Title>
                    </div>
                    <Row className="f-layout-vertical-border">
                        {recommendationModules &&
                            recommendationModules.map((module) => (
                                <Col xs={24} lg={12}>
                                    <Card
                                        title={t(module.title)}
                                        className={`f-dashboard-card-wrapper ${
                                            module.moduleId === 'HighUsageEntities' ||
                                            module.moduleId === 'RecentlyEditedEntities' ||
                                            module.moduleId === 'RecentlyViewedEntities'
                                                ? 'f-recent-most-viewed-card-wrapper'
                                                : ''
                                        }`}
                                    >
                                        <RecommendationModule
                                            module={module as RecommendationModuleType}
                                            scenarioType={scenario}
                                            showTitle={false}
                                        />
                                    </Card>
                                </Col>
                            ))}
                    </Row>
                </div>
            )}
        </>
    );
};
